"use strict";

exports.__esModule = true;
exports.ReportCollectionContext = void 0;
var _Utils = require("../../../Utils");
var _ReportCollection = require("./ReportCollection");
/**
 * Provides a collection of reports to consumers.
 * @component
 */
var ReportCollectionContext = exports.ReportCollectionContext = (0, _Utils.createEnhancedContext)({
  propName: "reportCollection",
  defaultController: _ReportCollection.ReportCollection
});